import { graphql, Link, useStaticQuery, navigate } from "gatsby"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"
import React, { useEffect, useState } from "react"
import { SlotType, SlotsWithFilterData } from "../../types/contentful.types"
import { BallTriangle } from "react-loader-spinner"
import SlotGamePopup from "../slot-game-popup"
import { useLocation } from "@reach/router"
import {
  pathToString,
  stringToPath,
} from "../../utilities/string-path-convertor"

const SlotsWithFilter = ({ onDownloadClick, slots }) => {
  const [filteredSlots, setFilteredSlots] = useState<SlotType[] | null>(null)
  const [activeGameSlot, setActiveGameSlot] = useState(null)
  const { pathname } = useLocation()

  const {
    allContentfulSlotCategory: { edges: categories },
  }: SlotsWithFilterData = useStaticQuery(graphql`
    query SlotsCategoriesQuery {
      allContentfulSlotCategory(sort: { order: ASC, fields: title }) {
        edges {
          node {
            title
            id
          }
        }
      }
    }
  `)

  const SLOTS_PER_PAGE = 20
  const [page, setPage] = useState(2)
  const [slotsSlice, setSlotsSlice] = useState(SLOTS_PER_PAGE)

  useEffect(() => {
    setSlotsSlice(SLOTS_PER_PAGE * page)

    if (stringToPath(pathname) === "slot-games") {
      setFilteredSlots(slots.slice(0, slotsSlice))
    } else {
      const filtered = slots.filter((slot) => {
        if (!slot.categories) return null
        else if (!slot.compose__page) return null
        return slot.categories
          .map(
            (category) =>
              category.title.toLowerCase().split(" ").join("-") ===
              pathname.replace("/slot-games/", "")
          )
          .includes(true)
      })
      setFilteredSlots(filtered.slice(0, slotsSlice))
    }
  }, [page])

  const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // slots type page slug needs to be as slot type title
    if (e.target.value == "slot-games") {
      navigate(`/${stringToPath(e.target.value)}`)
    } else {
      navigate(`/slot-games/${stringToPath(e.target.value)}`)
    }
  }

  if (!filteredSlots) {
    return (
      <div className='flex justify-center items-center pb-48'>
        <BallTriangle color='#eb2c8c' ariaLabel='loading-indicator' />
      </div>
    )
  }

  return (
    <div className='slots-with-filter-container p-8 md:p-10'>
      <SlotGamePopup
        slot={activeGameSlot}
        onCloseClick={() => setActiveGameSlot(null)}
        onDownloadClick={onDownloadClick}
      />

      <div className='slots-select-container text-center text-white'>
        <div className='flex flex-col items-center justify-center'>
          <div className='text-4xl font-bold'>SELECT YOUR SLOTS</div>
          <div className='select mb-8 mt-5'>
            <select
              className='slots-filter-select'
              defaultValue={pathToString(pathname.replace("/slot-games/", ""))}
              onChange={handleFilterChange}
            >
              <option value='slot-games'>All Slots</option>
              {categories.map((category) => (
                <option value={category.node.title} key={category.node.id}>
                  {category.node.title}
                </option>
              ))}
            </select>
            <div className='select-arrow'></div>
          </div>
        </div>
      </div>
      <div className='inner-container'>
        <div className='slots-filtered-container grid grid-cols-3 xl:grid-cols-5 gap-y-5 xl:gap-y-10'>
          {filteredSlots.map((item) => {
            if (!item.compose__page || !item.compose__page[0]) return

            return (
              <div
                className='carousel-item hover-glow text-center'
                key={Math.random()}
              >
                <div className='item-links p-8 flex flex-col justify-center items-center space-y-2'>
                  {item.gameIframeUrl && (
                    <button
                      // @ts-ignore
                      onClick={() => setActiveGameSlot(item)}
                      className='play-demo-button'
                    >
                      Play Demo
                    </button>
                  )}
                  {item.slotInfoLink && (
                    <Link
                      to={`/${item.compose__page[0].slug}`}
                      className='block text-white text-2xl underline'
                    >
                      Slot Info
                    </Link>
                  )}
                </div>
                <GatsbyImage
                  className='item-img'
                  image={
                    getImage(
                      item.slotIcon.localFile.childImageSharp
                        .gatsbyImageData
                    )!
                  }
                  alt={item.compose__page[0].title}
                />
                <Link
                  to={`/${item.compose__page[0].slug}`}
                  className='mobile-click'
                ></Link>
                <div className="text-white text-[9px] xl:text-[18px] pl-2 xl:pl-7 slot-title">
                  {item.compose__page[0].title.replace("SLOT MACHINE", "")}
                </div>
              </div>
            )
          })}
        </div>
        {SLOTS_PER_PAGE * (page - 1) <= filteredSlots.length && (
          <div className='flex justify-center items-center mt-20'>
            <button
              className='purple-button font-bold text-white text-2xl xl:text-4xl text-center'
              onClick={() => setPage((current) => current + 1)}
            >
              <span>LOAD MORE SLOT GAMES</span>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default SlotsWithFilter
